<div>
  <app-titlebar #titlebar [homeVisible]="true">
  </app-titlebar>
</div>
<mat-tab-group #masterTabGroup class="jk-tab-group" (selectedTabChange)="onMasterTabChange($event)">
  <mat-tab #myTabGrid label="條件設定">
    <mat-toolbar class="h-9">
      <button class="btn-primary" (click)="doMyQuery()">
        <mat-icon fontIcon="search"></mat-icon>查詢
      </button>
      <button class="btn-primary" (click)="doGetPreFilter()">
        <mat-icon fontIcon="search"></mat-icon>取前次
      </button>
    </mat-toolbar>
    <div class="jk-grid-cols-4"> <!-- grid two column grid grid-cols-1 gap-6 xl:grid-cols-2 -->
      <app-jkbtnedit [label]="'程式代號'" [maintable]="'ADMMB'" [item]="'W01'" [(value)]="ka004" [valueExpr]="'MB001'" [width]="'60'"
        [displayExpr]="'MB002'"></app-jkbtnedit>
      <div>
        <app-jkedit label="寄件人帳號" [(value)]="pageOpt.mailFrom" [required]="true"
          >
        </app-jkedit>
      </div>
      <div>
        <app-jkedit label="寄件人名稱" [(value)]="pageOpt.mailName" [required]="true"
          >
        </app-jkedit>
      </div>
      <div>
        <app-jkedit label="收件人帳號" [(value)]="pageOpt.mailTo" [required]="true"
          >
        </app-jkedit>
      </div>
    </div>

  </mat-tab>
  <mat-tab #myTabGrid label="明細">
    <mat-tab-group class="h-[40px]" (selectedTabChange)="onJobTabChange($event)">
      <mat-tab label="未執行工作">
        <mat-toolbar class="h-9">
          <button class="btn-primary" (click)="doMyQuery()">
            <mat-icon fontIcon="search"></mat-icon>重新整理
          </button>
          <button class="btn-primary" (click)="doRunNow()">
            立即執行
          </button>
          <button class="btn-primary" (click)="doDelete()">
            刪除
          </button>
        </mat-toolbar>
      </mat-tab>
      <mat-tab label="已執行工作">
        <mat-toolbar class="h-9">
          <button class="btn-primary" (click)="doMyQuery()">
            <mat-icon fontIcon="search"></mat-icon>重新整理
          </button>
          <button class="btn-primary" (click)="doChangeNotYet()">
            改未執行
          </button>
          <button class="btn-primary" (click)="doDelete()">
            刪除
          </button>
        </mat-toolbar>
      </mat-tab>
      <mat-tab label="預定執行工作">
        <mat-toolbar class="h-9">
          <button class="btn-primary" (click)="doMyQuery()">
            <mat-icon fontIcon="search"></mat-icon>重新整理
          </button>
          <button class="btn-primary" (click)="doChangeNotYet()">
            立即執行
          </button>
          <button class="btn-primary" (click)="doDelete()">
            刪除
          </button>
        </mat-toolbar>
      </mat-tab>
      <mat-tab #myJobSetup label="定時工作(週期性)">
        <button (click)="doMyQuery()" class="btn-neutral">重新顯示</button>
      </mat-tab>
      <mat-tab #myJobSetup label="報表">
        <button (click)="doMyQuery()" class="btn-neutral">重新顯示</button>
      </mat-tab>

    </mat-tab-group>
    @if(kind === 4){
      <span class="text-2xl">表格點兩下打開報表</span>
    }
    <app-jkgridwin #jkgridwin id="jkgridwin" [width]="screenWidth" [defaultHeight]="500" (rowClicked)="agRowClicked($event)"
      (doubleClick)="agRowDoubleClicked($event)" (afterGridReady)="afterGridReady($event)">
    </app-jkgridwin>
    <div class=" w-200 border-blue-800 border-2">
      <!-- <app-dispatcher-param [params]="ka014" [style]="ka008" ></app-dispatcher-param> -->
    </div>
  </mat-tab>

  <mat-tab #myPdf label="PDF報表檢視">
    <mat-toolbar class="h-9">
      <button (click)="doMail()" class="btn-neutral">傳MAIL</button>
      <app-jkdownload #jkdownload [url]="reportSrv.urlPath" [fileName]="reportSrv.fileName">
      </app-jkdownload>
    </mat-toolbar>
    <app-jktext [label]="'網址:'" [value]="reportSrv.urlPath"></app-jktext>
    <iframe [src]="reportSrv.urlPath | safe: 'resourceUrl' " type="application/pdf" width="100%" height="800px">
    </iframe>
  </mat-tab>
</mat-tab-group>

